<template>
  <div id="app">
    <myNav></myNav>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html, body {
  margin: 0;
  padding: 0;
}
a {
  font-style: normal;
  color: #fff;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue